module.exports = __webpack_public_path__ + "img/word.f13dbe82.png";